// extracted by mini-css-extract-plugin
export default {"container":"Stepper_container__4k3Xu","active":"Stepper_active__IPuZm","icon":"Stepper_icon__2Sces"};